import { connectRouter, routerMiddleware } from 'connected-react-router';
import amplitudeMiddleware from './middleware/analytics';
import { History } from 'history';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import { IApplicationState, reducers } from '.';
import ReduxLogger from './middleware/ReduxLogger';



const isLocalhost = typeof window !== "undefined" && window.location.hostname === "localhost";

export default function configureStore(history: History, initialState?: IApplicationState) {
    const middleware = [thunk, routerMiddleware(history), amplitudeMiddleware()];

    if (isLocalhost) {
        console.warn(`Detected dev debug session on local host ; adding redux logger to store middlware config`);
        //add it to the front so it logs the action before any transforms
        middleware.unshift(ReduxLogger);
    }

    const rootReducer = combineReducers({
        ...reducers,
        router: connectRouter(history),
    });

    const enhancers = [];
    const windowIfDefined = typeof window === 'undefined' ? null : (window as any);
    if (windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__) {
        enhancers.push(windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__());
    }

    return createStore(rootReducer, initialState, compose(applyMiddleware(...middleware), ...enhancers));
}
